var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visibleBadgeSlots.length > 0
    ? _c(
        "div",
        { staticClass: "product-badges" },
        _vm._l(_vm.visibleBadgeSlots, function (slot) {
          return _c(
            _vm.slotHref(slot) ? "a" : "span",
            _vm._b(
              {
                key: slot,
                tag: "component",
                staticClass: "badge",
                class: _vm.slotClasses(slot),
                style: _vm.slotStyle(slot),
                attrs: { href: _vm.slotHref(slot) },
              },
              "component",
              _vm.slotHref(slot) ? _vm.badgeLinkAttrs : {},
              false
            ),
            [_vm._v("\n    " + _vm._s(_vm.slotLabel(slot)) + "\n  ")]
          )
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }